import { PropsWithChildren } from 'react';

import cn from 'classnames';

import { BaseComponentProps } from '../../../types/common';
import { H5, H6 } from '../Typography';

import styles from './Link.module.css';

export type LinkProps = PropsWithChildren<BaseComponentProps> & {
  /**
   * Color of the link
   */
  color?: 'blue' | 'black';

  /**
   * Size of the link
   */
  size?: 's' | 'm';
} & (
    | ({
        as?: 'a';
      } & Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'className'>)
    | ({
        as?: 'span';
      } & Omit<React.HTMLAttributes<HTMLSpanElement>, 'className'>)
  );

const Typography = {
  s: H6,
  m: H5,
};

export const Link: React.FC<LinkProps> = ({
  children,
  color = 'blue',
  size = 's',
  dataTestId,
  as = 'a',
  ...rest
}) => {
  const Component = as;
  const TypographyComponent = Typography[size];

  return (
    <Component
      {...rest}
      className={cn(styles.link, {
        [styles[`color-${color}`]]: color,
      })}
      data-testid={dataTestId}
    >
      <TypographyComponent color="inherit">{children}</TypographyComponent>
    </Component>
  );
};

/**
 * Component with proper styling for links (like `<a>`)
 * Assepts `as` prop to render as `a` or `span` (and accept different props for each)
 */
export const LinkStory = (props: LinkProps) => {
  return <Link {...props} />;
};
